import { render, staticRenderFns } from "./main-expansion-panel.vue?vue&type=template&id=2218fa70&scoped=true"
import script from "./main-expansion-panel.vue?vue&type=script&lang=js"
export * from "./main-expansion-panel.vue?vue&type=script&lang=js"
import style0 from "./main-expansion-panel.vue?vue&type=style&index=0&id=2218fa70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218fa70",
  null
  
)

export default component.exports